/**
 * LEGAL / BUSINESS DETAILS - one file, imported by every legal page, the footer
 * and the form-consent notes.
 *
 * Values that are not known are `null` and the pages simply leave that line out.
 * Nothing here is invented. Fill the nulls in (or set the env vars) and every
 * page updates.
 */
export const LEGAL_LAST_UPDATED = "October 24, 2026";

export const BUSINESS = {
  legalName: "Apex Flow Labs LLC",
  storeName: "Apex Flow Digital",
  location: "Galt, California, United States",
  /** Owner ruling 2026-10-24: ONE public address for support, privacy, deletion, takedown and legal notices. */
  contactEmail: process.env.NEXT_PUBLIC_LEGAL_CONTACT_EMAIL || "info@apexflowlabs.com",
  /** Published in the footer since launch. */
  phone: "+1 916-720-3292",
  /** Street/PO box address. Left out of the pages until set. */
  mailingAddress: process.env.NEXT_PUBLIC_LEGAL_MAILING_ADDRESS || "10400 Twin Cities Rd, Ste 20, Galt, CA 95632, United States",
  /** Name + address of the DMCA designated agent registered with the U.S. Copyright Office. Not known: leave null. */
  dmcaAgentRegistration: process.env.NEXT_PUBLIC_DMCA_AGENT_REG_NUMBER || null,
} as const;

/** Key used for the cookie choice. Unchanged from the original banner so existing visitors keep their choice. */
export const CONSENT_KEY = "apex_cookie_consent";
export const CONSENT_EVENT = "apex:consent";
export const CONSENT_OPEN_EVENT = "apex:consent-open";

/** Every outside company that handles visitor or buyer data for this site. Keep in step with the privacy policy. */
export const SERVICE_PROVIDERS = [
  { name: "Vercel", purpose: "website hosting, delivery and security", optional: false },
  { name: "Supabase", purpose: "account sign-in and order records", optional: false },
  { name: "Stripe", purpose: "card payment processing (we never see your full card number)", optional: false },
  { name: "Resend", purpose: "sending receipts, download links and account emails", optional: false },
  { name: "Cloudflare R2 and similar storage", purpose: "storing and delivering the files you download and product images", optional: false },
  { name: "AI model providers", purpose: "answering chat questions and generating some product content", optional: false },
  { name: "Google (model-viewer, YouTube thumbnails)", purpose: "showing 3D previews and video posters", optional: false },
  { name: "Google Analytics / Google Ads", purpose: "usage statistics and ad measurement", optional: true },
  { name: "Meta Pixel", purpose: "ad measurement and audiences", optional: true },
  { name: "TikTok Pixel", purpose: "ad measurement and audiences", optional: true },
  { name: "Microsoft Clarity", purpose: "anonymised session recordings and heatmaps", optional: true },
  { name: "Klaviyo", purpose: "email list and onsite tracking", optional: true },
  { name: "Luke’s Arcade widget (apexflowlabs.com)", purpose: "the Play button, scores and Apex ID", optional: true },
  { name: "Facebook Page plugin", purpose: "showing our Facebook page feed on some pages", optional: true },
] as const;
